import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { formatPhone } from "../../formatters";
export const FormatPhone = (props)=>{
    const formattedValue = formatPhone(props.value);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: formattedValue
    });
};
FormatPhone.displayName = 'FormatPhone';

//# sourceMappingURL=FormatPhone.js.map